import React, { useEffect, useState } from "react";

import API from "../../Helpers/Constants/EndPoints/Api";
import Axios from "../../Helpers/Universal/Axios/Axios";
import Loader from "../Common/Loader";
import { CONFIG } from "../../Helpers/Constants/Default";
import ConfigModal from "../Common/ConfigModal";
import AppVersionModal from "../Common/AppVersionModal";

const Config = () => {
  const [data, setData] = useState([]);
  const [appVersions, setAppVersions] = useState([]);
  const [visible, setVisible] = useState({ loader: false });
  const [modalData, setModalData] = useState({ visible: false, data: {} });
  const [appVersionModal, setAppVersionModal] = useState({ visible: false, data: {} });

  const getData = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(API.CONFIG.DETAILS);
      if (status) setData(data);
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const getAppVersions = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(API.APP_VERSION.LIST);
      // Correctly bind list response: data.data if it matches the nested structure
      if (status) {
        setAppVersions(data?.data || data || []);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  useEffect(() => {
    getData();
    getAppVersions();
  }, []);

  // Helper to convert seconds to HH:MM:SS
  const formatSeconds = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <>
      {visible.loader && <Loader />}
      {modalData.visible && (
        <ConfigModal
          modalData={modalData}
          setModalData={setModalData}
          setVisible={setVisible}
          setData={setData}
        />
      )}
      {appVersionModal.visible && (
        <AppVersionModal
          modalData={appVersionModal}
          setModalData={setAppVersionModal}
          setVisible={setVisible}
          setData={setAppVersions}
        />
      )}
      <div className="container-fluid py-3">
        {/* Time Configuration Section */}
        <div className="inner-form mb-4">
          <h5 className="text-white mb-4">Time Configuration</h5>

          <div className="table-responsive">
            <table className="table table-dark align-items-center mb-0">
              <thead>
                <tr>
                  <th className="text-white text-xs fw-bold">Type</th>
                  <th className="text-white text-xs fw-bold">Value</th>
                  <th className="text-end text-white text-xs fw-bold">Action</th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data.map((val) => (
                    <tr key={val._id}>
                      <td>
                        <span className="text-white fw-xs fs-xs">
                          {CONFIG.TYPE[val.type]}
                        </span>
                      </td>

                      <td>
                        <span
                          className="fw-bold fs-xs text-white"
                          style={{ letterSpacing: "1px" }}
                        >
                          {formatSeconds(val.value)}
                        </span>
                      </td>

                      <td className="text-end">
                        <button
                          className="btn btn-sm bg-gradient-dark"
                          onClick={() =>
                            setModalData({ visible: true, data: val })
                          }
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-3 text-secondary">
                      No configuration found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* App Version Configuration Section */}
        {/* <div className="inner-form">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="text-white mb-0">App Version Configuration</h5>
            <button
              className="btn bg-gradient-dark btn-md mb-0"
              onClick={() => setAppVersionModal({ visible: true, data: {} })}
            >
              Add New Version
            </button>
          </div>

          <div className="row">
            {appVersions?.map((val) => (
              <div key={val._id} className="col-md-12 mb-3">
                <div className="p-3 border border-secondary rounded bg-dark-blue">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <span className={`badge badge-sm w-100 ${val.platform === 'android' ? 'bg-gradient-success' : 'bg-gradient-info'}`}>
                        {val.platform?.toUpperCase()}
                      </span>
                    </div>
                    <div className="col-md-2">
                      <h6 className="text-white mb-0">v{val.currentVersion}</h6>
                      <p className="text-xxs text-secondary mb-0">Build: {val.buildNumber}</p>
                    </div>
                    <div className="col-md-3">
                      <p className="text-xs text-white mb-0">Min Supported: v{val.minSupportedVersion}</p>
                      <p className="text-xxs text-secondary mb-0">Min Build: {val.minSupportedBuildNumber}</p>
                    </div>
                    <div className="col-md-2 text-center">
                      <span className={`badge badge-sm ${val.isSkippable ? 'bg-gradient-secondary' : 'bg-gradient-danger'}`}>
                        {val.isSkippable ? 'Skippable' : 'Mandatory'}
                      </span>
                    </div>
                    <div className="col-md-3 text-end">
                      <button
                        className="btn btn-link text-white p-0 mb-0"
                        onClick={() => setAppVersionModal({ visible: true, data: val })}
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {appVersions?.length === 0 && (
              <div className="col-12 text-center py-4">
                <p className="text-secondary mb-0">No app versions found</p>
              </div>
            )}
          </div>
        </div> */}
        <div className="inner-form">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="text-white mb-0">App Version Configuration</h5>
            <button
              className="btn bg-gradient-dark btn-md mb-0"
              onClick={() => setAppVersionModal({ visible: true, data: {} })}
            >
              Add New Version
            </button>
          </div>

          <div className="table-responsive">
            <table className="table align-items-center mb-0 table-dark">
              <thead>
                <tr>
                  <th>Platform</th>
                  <th>Architecture</th>
                  <th>Current Version</th>
                  <th>Build</th>
                  <th>Min Version</th>
                  <th>Min Build</th>
                  <th>Update Type</th>
                  <th>Status</th>
                  <th>Release Notes</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {appVersions?.length > 0 ? (
                  appVersions.map((val) => (
                    <tr key={val._id}>

                      {/* Platform */}
                      <td>
                        <span
                          className={`badge ${val.platform === "android"
                            ? "bg-success"
                            : "bg-info"
                            }`}
                        >
                          {val.platform?.toUpperCase()}
                        </span>
                      </td>

                      {/* Architecture */}
                      <td>{val.architecture || "-"}</td>

                      {/* Current Version */}
                      <td>v{val.currentVersion}</td>

                      {/* Build */}
                      <td>{val.buildNumber}</td>

                      {/* Min Version */}
                      <td>v{val.minSupportedVersion}</td>

                      {/* Min Build */}
                      <td>{val.minSupportedBuildNumber}</td>

                      {/* Update Type */}
                      <td>
                        <span
                          className={`badge ${val.isSkippable
                            ? "bg-secondary"
                            : "bg-danger"
                            }`}
                        >
                          {val.isSkippable ? "Skippable" : "Mandatory"}
                        </span>
                      </td>

                      {/* Status */}
                      <td>
                        <span
                          className={`badge ${val.isActive ? "bg-success" : "bg-secondary"
                            }`}
                        >
                          {val.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>

                      {/* Release Notes */}
                      <td className="text-truncate" style={{ maxWidth: "150px" }}>
                        {val.releaseNotes || "-"}
                      </td>

                      {/* Action */}
                      <td>
                        <button
                          className="btn btn-sm btn-outline-light"
                          onClick={() =>
                            setAppVersionModal({ visible: true, data: val })
                          }
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-4 text-secondary">
                      No app versions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Config;
